export enum ProvincesEs {
	P01 = 'Álava (Vitoria)',
	P02 = 'Albacete',
	P03 = 'Alicante',
	P04 = 'Almería',
	P05 = 'Ávila',
	P06 = 'Badajoz',
	P07 = 'Baleares (Palma de Mallorca)',
	P08 = 'Barcelona',
	P09 = 'Burgos',
	P10 = 'Cáceres',
	P11 = 'Cádiz',
	P12 = 'Castellón',
	P13 = 'Ciudad Real',
	P14 = 'Córdoba',
	P15 = 'Coruña',
	P16 = 'Cuenca',
	P17 = 'Gerona',
	P18 = 'Granada',
	P19 = 'Guadalajara',
	P20 = 'Guipúzcoa (San Sebastián)',
	P21 = 'Huelva',
	P22 = 'Huesca',
	P23 = 'Jaén',
	P24 = 'León',
	P25 = 'Lérida',
	P26 = 'La Rioja (Logroño)',
	P27 = 'Lugo',
	P28 = 'Madrid',
	P29 = 'Málaga',
	P30 = 'Murcia',
	P31 = 'Navarra (Pamplona)',
	P32 = 'Orense',
	P33 = 'Asturias (Oviedo)',
	P34 = 'Palencia',
	P35 = 'Las Palmas',
	P36 = 'Pontevedra',
	P37 = 'Salamanca',
	P38 = 'Santa Cruz de Tenerife',
	P39 = 'Cantabria (Santander)',
	P40 = 'Segovia',
	P41 = 'Sevilla',
	P42 = 'Soria',
	P43 = 'Tarragona',
	P44 = 'Teruel',
	P45 = 'Toledo',
	P46 = 'Valencia',
	P47 = 'Valladolid',
	P48 = 'Vizcaya (Bilbao)',
	P49 = 'Zamora',
	P50 = 'Zaragoza',
	P51 = 'Ceuta',
	P52 = 'Melilla',
}

export enum ProvincesIt {
	AG = 'Agrigento',
	AL = 'Alessandria',
	AN = 'Ancona',
	AR = 'Arezzo',
	AP = 'Ascoli Piceno',
	AT = 'Asti',
	AV = 'Avellino',
	BA = 'Bari',
	BT = 'Barletta-Andria-Trani',
	BL = 'Belluno',
	BN = 'Benevento',
	BG = 'Bergamo',
	BI = 'Biella',
	BO = 'Bologna',
	BZ = 'Bolzano/Bozen',
	BS = 'Brescia',
	BR = 'Brindisi',
	CA = 'Cagliari',
	CL = 'Caltanissetta',
	CB = 'Campobasso',
	CE = 'Caserta',
	CT = 'Catania',
	CZ = 'Catanzaro',
	CH = 'Chieti',
	CO = 'Como',
	CS = 'Cosenza',
	CR = 'Cremona',
	KR = 'Crotone',
	CN = 'Cuneo',
	EN = 'Enna',
	FM = 'Fermo',
	FE = 'Ferrara',
	FI = 'Firenze',
	FG = 'Foggia',
	FC = 'Forlì-Cesena',
	FR = 'Frosinone',
	OT = 'Gallura Nord-Est Sardegna',
	GE = 'Genova',
	GO = 'Gorizia',
	GR = 'Grosseto',
	IM = 'Imperia',
	IS = 'Isernia',
	SP = 'La Spezia',
	AQ = "L'Aquila",
	LT = 'Latina',
	LE = 'Lecce',
	LC = 'Lecco',
	LI = 'Livorno',
	LO = 'Lodi',
	LU = 'Lucca',
	MC = 'Macerata',
	MN = 'Mantova',
	MS = 'Massa-Carrara',
	MT = 'Matera',
	VS = 'Medio Campidano',
	ME = 'Messina',
	MI = 'Milano',
	MO = 'Modena',
	MB = 'Monza e della Brianza',
	NA = 'Napoli',
	NO = 'Novara',
	NU = 'Nuoro',
	OG = 'Ogliastra',
	OR = 'Oristano',
	PD = 'Padova',
	PA = 'Palermo',
	PR = 'Parma',
	PV = 'Pavia',
	PG = 'Perugia',
	PU = 'Pesaro e Urbino',
	PE = 'Pescara',
	PC = 'Piacenza',
	PI = 'Pisa',
	PT = 'Pistoia',
	PN = 'Pordenone',
	PZ = 'Potenza',
	PO = 'Prato',
	RG = 'Ragusa',
	RA = 'Ravenna',
	RC = 'Reggio Calabria',
	RE = "Reggio nell'Emilia",
	RI = 'Rieti',
	RN = 'Rimini',
	RM = 'Roma',
	RO = 'Rovigo',
	SA = 'Salerno',
	SS = 'Sassari',
	SV = 'Savona',
	SI = 'Siena',
	SR = 'Siracusa',
	SO = 'Sondrio',
	CI = 'Sulcis Iglesiente',
	TA = 'Taranto',
	TE = 'Teramo',
	TR = 'Terni',
	TO = 'Torino',
	TP = 'Trapani',
	TN = 'Trento',
	TV = 'Treviso',
	TS = 'Trieste',
	UD = 'Udine',
	AO = "Valle d'Aosta/Vallée d'Aoste",
	VA = 'Varese',
	VE = 'Venezia',
	VB = 'Verbano-Cusio-Ossola',
	VC = 'Vercelli',
	VR = 'Verona',
	VV = 'Vibo Valentia',
	VI = 'Vicenza',
	VT = 'Viterbo',
	EE = 'Estero',
	SU = 'Sud Sardegna',
}
